import React from 'react';
import './Card.css';

const Card = ({
  children,
  variant = 'default',
  className = '',
  onClick,
  ...props
}) => {
  const baseClass = 'linear-card';
  const variantClass = `linear-card--${variant}`;
  const classes = `${baseClass} ${variantClass} ${className}`.trim();
  const Component = onClick ? 'button' : 'div';

  return (
    <Component
      className={classes}
      onClick={onClick}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Card;


